import { styled, css, Dialog, Box, BoxProps, DialogProps } from '@mui/material'
import { getUnitValue } from '../../../utils/processStyles'
import { ModalBoxStylesProps } from './ModalBox.types'

const alignMap = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end'
}

export const ModalBoxDialog = styled(Dialog, {
  shouldForwardProp: (prop) => !['maxHeight'].includes(String(prop))
})<DialogProps & ModalBoxStylesProps>(
  ({ theme, padding, align }) => css`
    > .MuiDialog-container {
      > .MuiPaper-root {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: ${alignMap[align || 'center']};
        align-items: center;
        width: 100%;
        height: 100%;
        max-height: 100%;
        margin: 0;

        padding: ${getUnitValue(padding)};
        background: none;
        box-shadow: none;

        ${theme.breakpoints.up('sm')} {
          border-radius: 8px;
          max-width: 360px;
          max-height: 760px;
        }
      }
    }

    .MuiBackdrop-root {
      background-color: rgba(0, 0, 0, 0.3);
    }
  `
)
ModalBoxDialog.defaultProps = {
  padding: 0,
  maxHeight: 100,
  fullScreen: true
}

export const ModalBoxWrapper = styled(Box, {
  shouldForwardProp: (prop) => !['maxH', 'fullScreen'].includes(String(prop))
})<BoxProps & ModalBoxStylesProps>(
  ({ theme, fullScreen, padding, radius, maxHeight, align }) => css`
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    max-height: ${getUnitValue(maxHeight, '%')};
    min-height: ${fullScreen ? '100%' : '56px'};
    height: ${fullScreen ? '100%' : 'auto'};
    width: 100%;
    padding: 0;
    gap: 0;
    background-color: ${theme.palette.background.default};
    border-radius: ${getUnitValue(radius)};

    // if is fullscreen and doesn't have a padding
    ${fullScreen &&
    !padding &&
    css`
      border-radius: 0;
    `}

    // if is not fullscreen and doesn't have a padding and is align bottom
    ${!fullScreen &&
    !padding &&
    align === 'bottom' &&
    css`
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    `}

    // if is not fullscreen and doesn't have a padding and is align top
    ${!fullScreen &&
    !padding &&
    align === 'top' &&
    css`
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    `}
  `
)
ModalBoxWrapper.defaultProps = {
  fullScreen: true,
  maxHeight: 100,
  radius: 8
}
